import { useState } from "react";
import arrowDown from "../assets/arrowDown.svg";

export default function SelectList({ label, value, option, onSelect }) {
    const [isOpen, setIsOpen] = useState(false)
    const handleToggle = () => {
        setIsOpen(!isOpen)
    }
    const selectedOption = option.find((el) => el.value === value);
    return <div className="select-list">
        <p className="select-list__text">{label}</p>
        <div
            className="select-list__select"
            onClick={handleToggle}
        >
            <p className="select-list__select__text">
                {selectedOption ? selectedOption.label : label}
            </p>
            <div className="select-list__select__imgWrapper">
                <img
                    src={arrowDown}
                    alt="arrowDown"
                    className="select-list__select__imgWrapper__img"
                    style={
                        !isOpen
                            ? null
                            : {
                                transform: "rotate(180deg)",
                            }
                    }
                />
            </div>
        </div>
        {isOpen ? (
            <div className="select-list__option">
                {option.map((el, ind) => (
                    <p
                        onClick={() => {onSelect(el.value);handleToggle()}}
                        className="select-list__option__label"
                        key={ind}
                    >
                        {el.label}
                    </p>
                ))}
            </div>
        ) : null}
    </div>
}